/**
 * Chapter content registry — maps a chapter slug to its `ChapterContent`.
 *
 * Each chapter ticket (CX-2726..2729) adds its entry here. The sub-page route
 * looks up the slug; an unknown slug renders the not-found fallback.
 */

import type { ChapterContent } from "../chapter.types";
import { designedToLastChapter } from "./designed-to-last.data";
import { digitalTwinsChapter } from "./digital-twins.data";
import { rebornChapter } from "./reborn.data";
import { renewedRestoredChapter } from "./renewed-restored.data";

export const chapterContentBySlug: Record<string, ChapterContent> = {
  [rebornChapter.slug]: rebornChapter,
  [renewedRestoredChapter.slug]: renewedRestoredChapter,
  [designedToLastChapter.slug]: designedToLastChapter,
  [digitalTwinsChapter.slug]: digitalTwinsChapter,
};
